import { jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Stack,
  Tooltip,
  useTheme
} from "@mui/material";
import { cloneElement } from "react";
function ActionBarItem(props) {
  const {
    id,
    icon,
    label,
    onClick,
    _internal,
    tooltip = "",
    disabled = false,
    color = "default",
    disableInteraction = false,
    testId = "tidal-actionbaritem",
    className = "",
    divider,
    mode,
    sx: propsSx,
    ...dataAttributes
  } = props;
  const theme = useTheme();
  if (!_internal) {
    console.warn("ActionBarItem must only be used as a child of ActionBar");
    return null;
  }
  const { size, menuMode, parentOnClick } = _internal;
  const btnColor = color === "default" ? void 0 : color;
  const handleClick = (event) => {
    if (disableInteraction) return;
    onClick?.(event);
    parentOnClick?.({ id, label });
  };
  const clonedIcon = cloneElement(icon, { fontSize: "inherit" });
  const sx = {
    ...disableInteraction ? { pointerEvents: "none" } : {},
    ...propsSx
  };
  const dividerSx = { height: "inherit" };
  if (mode === "menu") {
    const cssColor = color === "inherit" || color === "default" ? void 0 : (theme.vars ?? theme).palette[color].main;
    return /* @__PURE__ */ jsxs(
      MenuItem,
      {
        sx,
        disabled,
        onClick: handleClick,
        "data-testid": testId,
        className,
        divider,
        ...dataAttributes,
        children: [
          menuMode === "textIcon" && /* @__PURE__ */ jsx(ListItemIcon, { sx: { color: cssColor }, children: icon }),
          /* @__PURE__ */ jsx(ListItemText, { sx: { color: cssColor }, children: label })
        ]
      }
    );
  }
  if (menuMode === "iconOnly") {
    return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: _internal.gap, children: [
      /* @__PURE__ */ jsx(Tooltip, { title: tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
        IconButton,
        {
          sx,
          size,
          color,
          disabled,
          onClick: handleClick,
          "data-testid": testId,
          className,
          disableRipple: disableInteraction,
          disableFocusRipple: disableInteraction,
          ...dataAttributes,
          children: clonedIcon
        }
      ) }) }),
      divider && /* @__PURE__ */ jsx(Divider, { sx: dividerSx, orientation: "vertical" })
    ] });
  }
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: _internal.gap, children: [
    /* @__PURE__ */ jsx(Tooltip, { title: tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
      Button,
      {
        sx,
        fullWidth: true,
        color: btnColor,
        disabled,
        "data-testid": testId,
        className,
        onClick: handleClick,
        disableRipple: disableInteraction,
        disableFocusRipple: disableInteraction,
        size: size === "tiny" ? "small" : size,
        startIcon: menuMode !== "textOnly" && clonedIcon,
        ...dataAttributes,
        children: label
      }
    ) }) }),
    divider && /* @__PURE__ */ jsx(Divider, { sx: dividerSx, orientation: "vertical" })
  ] });
}
export {
  ActionBarItem
};
//# sourceMappingURL=ActionBarItem.js.map
